const menuIcons = {
  menuIconArchive: 'fa-archive',
  menuIconArrowLeft: 'fa-arrow-left',
  menuIconBarChart: 'fa-file',
  menuIconBus: 'fa-bus',
  menuIconClipboardList: 'fa-clipboard-list',
  menuIconCog: 'fa-cog',
  menuIconCurrency: 'fa-dollar-sign',
  menuIconFlag: 'fa-flag',
  menuIconFolder: 'fa-folder',
  menuIconFolderOpen: 'fa-folder-open',
  menuIconGasPump: 'fa-gas-pump',
  menuIconMail: 'fa-envelope',
  menuIconMap: 'fa-map',
  menuIconMapMarkerAlt: 'fa-map-marker-alt',
  menuIconRss: 'fa-rss',
  menuIconSignal: 'fa-signal',
  menuIconTicket: 'fa-ticket-alt',
  menuIconTrophy: 'fa-trophy',
  menuIconUser: 'fa-user',
  menuIconUsers: 'fa-users',
  menuIconUserFriends: 'fa-user-friends',
  menuIconUpload: 'fa-upload',
  menuIconVehicles: 'fa-car',
  menuIconWrench: 'fa-wrench',
}

const projectKeys = {
  AD_OPERATOR: 'AD_OPERATOR',
  AD_ADMINISTRATOR: 'AD_ADMINISTRATOR',
  LD: 'LD',
  LEV: 'LEV',
  PTF: 'PTF',
  PPU: 'PPU',
  MRBPOR: 'MRBPOR',
}

const areaKeys = {
  AD: 'ADMINISTRATOR',
  LD: 'ADMINISTRATOR',
  LEV: 'ADMINISTRATOR',
  PTF: 'ADMINISTRATOR',
  PPU: 'OPERATOR',
  MRBPOR: 'ADMINISTRATOR',
}

export const externalPaths = {
  AD_ADMINISTRATOR: {
    DEMO: 'http://demo.portal.veyo.com/',
    DEV: 'http://test.portal.veyo.com/',
    TEST: 'http://test.portal.veyo.com/',
    INTEGRATION: 'http://integration.portal.veyo.com/',
    STAGING: 'http://integration.portal.veyo.com/',
    PROD: 'https://portal.veyo.com/',
    PRODUCTION: 'https://portal.veyo.com/',
    LIVE: 'https://portal.veyo.com/',
  },
  AD_OPERATOR: {
    DEMO: 'http://demo.providers.veyo.com/',
    DEV: 'http://test.providers.veyo.com/',
    TEST: 'http://test.providers.veyo.com/',
    INTEGRATION: 'http://integration.providers.veyo.com/',
    STAGING: 'http://integration.providers.veyo.com/',
    PROD: 'https://providers.veyo.com/',
    PRODUCTION: 'https://providers.veyo.com/',
    LIVE: 'https://providers.veyo.com/',
  },
  LEV: {
    DEMO: 'https://demo.veyo.io/portal/',
    DEV: 'https://test.veyo.io/portal/',
    TEST: 'https://test.veyo.io/portal/',
    INTEGRATION: 'https://integration.veyo.io/portal/',
    STAGING: 'https://staging.veyo.io/portal/',
    PROD: 'https://live.veyo.io/portal/',
    PRODUCTION: 'https://live.veyo.io/portal/',
    LIVE: 'https://live.veyo.io/portal/',
  },
  PTF: {
    DEMO: 'https://demo.veyo.io/transit/',
    DEV: 'https://test.veyo.io/transit/',
    TEST: 'https://test.veyo.io/transit/',
    INTEGRATION: 'https://integration.veyo.io/transit/',
    STAGING: 'https://staging.veyo.io/transit/',
    PROD: 'https://live.veyo.io/transit/',
    PRODUCTION: 'https://live.veyo.io/transit/',
    LIVE: 'https://live.veyo.io/transit/',
  },
  PPU: {
    DEMO: 'https://demo.veyo.io/provider/',
    DEV: 'https://test.veyo.io/provider/',
    TEST: 'https://test.veyo.io/provider/',
    INTEGRATION: 'https://integration.veyo.io/provider/',
    STAGING: 'https://staging.veyo.io/provider/',
    PROD: 'https://live.veyo.io/provider/',
    PRODUCTION: 'https://live.veyo.io/provider/',
    LIVE: 'https://live.veyo.io/provider/',
  },
  LD: {
    DEMO: 'https://demo.veyo.io/routing/',
    DEV: 'https://test.veyo.io/routing/',
    TEST: 'https://test.veyo.io/routing/',
    INTEGRATION: 'https://integration.veyo.io/routing/',
    STAGING: 'https://staging.veyo.io/routing/',
    PROD: 'https://live.veyo.io/routing/',
    PRODUCTION: 'https://live.veyo.io/routing/',
    LIVE: 'https://live.veyo.io/routing/',
  },
  MRBPOR: {
    DEMO: 'https://demo.veyo.io/mrb/',
    DEV: 'https://test.veyo.io/mrb/',
    TEST: 'https://test.veyo.io/mrb/',
    INTEGRATION: 'https://integration.veyo.io/mrb/',
    STAGING: 'https://staging.veyo.io/mrb/',
    PROD: 'https://live.veyo.io/mrb/',
    PRODUCTION: 'https://live.veyo.io/mrb/',
    LIVE: 'https://live.veyo.io/mrb/',
  }
}

export const linkIsInternal = (menuItemKey, projectKey) => {
  return menuItemKey.toUpperCase() === projectKey.toUpperCase();;
}

export const linkIsExternal = (menuItemKey, projectKey) => {
  return !linkIsInternal(menuItemKey, projectKey);
}

export const getPath = (menuItemKey, projectKey, environmentKey, route) => {

  // internal link
  if (linkIsInternal(menuItemKey, projectKey)) {
    return route;
  }

  if (!externalPaths[menuItemKey] || !externalPaths[menuItemKey][environmentKey]) {
    return 'invalid project or environment for menu'
  }

  // external link
  return externalPaths[menuItemKey][environmentKey] + route;
}

const getAdminMenu = (projectKey, environmentKey) => {
  return [
    {
      Name: 'Rescue Dispatch',
      Icon: menuIcons.menuIconRss,
      External: linkIsExternal(projectKeys.LEV, projectKey),
      Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'dispatch/ondemand'),
      Removable: false,
      Permissions: [{
        Action: 'Query',
        Name: 'DispatchTrips',
        Prefix: 'Portal',
        UserType: 'Administrator'
      }],
      Order: 0,
    },
    {
      Name: 'Peak Time Rewards',
      Icon: menuIcons.menuIconTrophy,
      External: false,
      Removable: false,
      Order: 1,
      SubItems: [
        {
          Name: 'Manage Campaigns',
          Icon: menuIcons.menuIconTrophy,
          External: linkIsExternal(projectKeys.LEV, projectKey),
          Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'campaigns/manage'),
          Removable: false,
          Order: 0,
          Permissions: [{
            Action: 'Query',
            Name: 'PeakTimeRewardCampaign',
            Prefix: 'Portal',
            UserType: 'Administrator'
          }],
        },
        {
          Name: 'Create Campaign',
          Icon: menuIcons.menuIconTrophy,
          External: linkIsExternal(projectKeys.LEV, projectKey),
          Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'campaigns/create'),
          Removable: false,
          Order: 1,
          Permissions: [{
            Action: 'Create',
            Name: 'PeakTimeRewardCampaign',
            Prefix: 'Portal',
            UserType: 'Administrator'
          },
          {
            Action: 'Update',
            Name: 'PeakTimeRewardCampaign',
            Prefix: 'Portal',
            UserType: 'Administrator'
          }
          ],
        }
      ]
    },
    {
      Name: 'Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: false,
      Removable: false,
      Order: 2,
      SubItems: []
    },
    {
      Name: 'Platform',
      Icon: menuIcons.menuIconArrowLeft,
      External: true,
      Path: getPath(projectKeys.AD_ADMINISTRATOR, projectKey, environmentKey, ''),
      Removable: false,
      Order: 4,
    },
  ]
}

const getOperatorMenu = (projectKey, environmentKey) => {
  return [
    {
      Name: 'Trip Management',
      Icon: menuIcons.menuIconRss,
      External: false,
      Removable: false,
      Order: 0,
      SubItems: [
        {
          Name: 'Accept Trips',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, ''),
          Removable: false,
          Order: 0,
          Permissions: [{
            Action: 'Query',
            Name: 'DispatchTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'View Accepted Trips',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'confirmed'),
          Removable: false,
          Order: 1,
          Permissions: [{
            Action: 'Query',
            Name: 'DispatchTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'Review Revised Trips',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'revisedTrips'),
          Removable: false,
          Order: 2,
          Permissions: [{
            Action: 'Query',
            Name: 'TripRevision',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'View Cancelled Trips',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'cancelled'),
          Removable: false,
          Order: 3,
          Permissions: [{
            Action: 'Query',
            Name: 'DispatchTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'Assign Trips to Drivers',
          Icon: menuIcons.menuIconUpload,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'driverassignment'),
          Removable: false,
          Order: 5,
          Permissions: [{
            Action: 'Import',
            Name: 'DispatchTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'Finalize Trips',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.PPU, projectKey),
          Path: getPath(projectKeys.PPU, projectKey, environmentKey, 'finalization'),
          Removable: false,
          Order: 6,
          Permissions: [{
            Action: 'Query',
            Name: 'Dispatch.FinalizationTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'Payment History',
          Icon: menuIcons.menuIconCurrency,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'paymentHistory'),
          Removable: false,
          Order: 7,
          Permissions: [{
            Action: 'Query',
            Name: 'Dispatch.PaymentHistory',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        {
          Name: 'Mercy Care Billing',
          Icon: menuIcons.menuIconMapMarkerAlt,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'mercyCareBilling'),
          Removable: false,
          Order: 8,
          Permissions: [{
            Action: 'Query',
            Name: 'ViewMercyCareTrips',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        }
      ]
    },
    {
      Name: 'Drivers',
      Icon: menuIcons.menuIconUser,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'drivers'),
      Order: 2,
      Permissions: [{
        Action: 'Query',
        Name: 'Driver',
        Prefix: 'Portal',
        UserType: 'Operator'
      }],
    },
    {
      Name: 'Vehicles',
      Icon: menuIcons.menuIconVehicles,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'vehicles'),
      Order: 2,
      Permissions: [{
        Action: 'Query',
        Name: 'Vehicle',
        Prefix: 'Portal',
        UserType: 'Operator'
      }],
    },
    {
      Name: 'Members',
      Icon: menuIcons.menuIconUsers,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'operatorMembers'),
      Order: 3,
      Permissions: [{
        Action: 'Query',
        Name: 'AutoAcceptMembersMenu',
        Prefix: 'Portal',
        UserType: 'Operator'
      }],
    },
    {
      Name: 'Manage',
      Icon: menuIcons.menuIconUsers,
      External: false,
      Removable: false,
      Order: 4,
      SubItems: [
        {
          Name: 'Operator Profile',
          Icon: menuIcons.menuIconCog,
          External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
          Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'operatorProfile'),
          Removable: false,
          Order: 0,
          Permissions: [{
            Action: 'Query',
            Name: 'ExtendedPropertyDescription',
            Prefix: 'Portal',
            UserType: 'Operator'
          }],
        },
        // {
        //   Name: 'Supported Products',
        //   Icon: menuIcons.menuIconCog,
        //   External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
        //   Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'operatorProfile'),
        //   Removable: false,
        //   Order: 1,
        //   Permissions: [{
        //     Action: 'Query',
        //     Name: 'OperatorProduct',
        //     Prefix: 'Portal',
        //     UserType: 'Operator'
        //   }],
        // },
      ]
    },
  ]
}

/**
 * 
 * @param {string} projectKey = LEV, AD, 
 */
export const getMenu = (projectKey, environmentKey) => {
  projectKey = projectKey.toUpperCase()
  environmentKey = environmentKey.toUpperCase()

  if (areaKeys[projectKey] === 'ADMINISTRATOR') {
    return getAdminMenu(projectKey, environmentKey);
  }

  if (areaKeys[projectKey] === 'OPERATOR') {
    return getOperatorMenu(projectKey, environmentKey);
  }
  return [];
}



// WEBPACK FOOTER //
// ./test/default-menu.js